import React from "react";
import {useTranslation} from "react-i18next";

import MDBox from "../../../materialDashboard/components/MDBox";
import MDTypography from "../../../materialDashboard/components/MDTypography";
import MDInput from "../../../materialDashboard/components/MDInput";

import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import WorkgroupAutocomplete from "../../../components/inputs/WorkgroupsAutocomplete/WorkgroupAutocomplete";
import StationTypeSelect from "../../../components/inputs/StationTypeSelect";


const IdentificationSection = ({station, formik}) => {
    const {t} = useTranslation(['stations']);

    return <Stack spacing={1}>
        <MDBox>
            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                {t('stationForm.identification')}
            </MDTypography>
        </MDBox>

        <WorkgroupAutocomplete name="workgroupId"
                               value={formik.values.workgroupId}
                               initialOption={station?.workgroup}
                               onChange={(workgroupId) => formik.setFieldValue('workgroupId', workgroupId)}
                               workgroupFilters={{
                                   acl__data_write: true,
                               }}
                               MDInputProps={{
                                   name: 'workgroupId',
                                   error: formik.touched.workgroupId && Boolean(formik.errors.workgroupId),
                                   helperText: formik.touched.workgroupId && formik.errors.workgroupId
                               }}/>
        <MDInput name="code"
                 label={t('stationForm.code')}
                 value={formik.values.code}
                 onChange={formik.handleChange}
                 error={formik.touched.code && Boolean(formik.errors.code)}
                 helperText={formik.touched.code && formik.errors.code}
                 variant="standard"
                 fullWidth
        />
        <MDInput name="name"
                 label={t('stationForm.name')}
                 value={formik.values.name}
                 onChange={formik.handleChange}
                 error={formik.touched.name && Boolean(formik.errors.name)}
                 helperText={formik.touched.name && formik.errors.name}
                 variant="standard"
                 fullWidth
        />
        <StationTypeSelect value={formik.values.type}
                           name="type"
                           onChange={formik.handleChange}
                           error={formik.touched.type && Boolean(formik.errors.type)}
                           helperText={formik.touched.type && formik.errors.type}
                           addEmptyItem={false}
                           fullWidth/>
        <MDInput name="visibility"
                 label={t('stationForm.visibility')}
                 value={formik.values.visibility}
                 onChange={formik.handleChange}
                 error={formik.touched.visibility && Boolean(formik.errors.visibility)}
                 helperText={formik.touched.visibility && formik.errors.visibility}
                 variant="standard"
                 fullWidth
                 select>
            {
                ["PUBLIC", "PRIVATE", "SHARED"].map(option => (
                    <MenuItem key={option} value={option}>
                        {t('enums:stationVisibility.' + option)}
                    </MenuItem>
                ))
            }
        </MDInput>
    </Stack>
}

export default IdentificationSection;